import { createContext } from 'preact';
import { DrillEquipment, GeneralInformation, TaskEntry } from './types';

interface DrillerProdContextProps {
    equipments: DrillEquipment;
    setEquipments: (equipments: DrillEquipment) => void;
    generalInformation: GeneralInformation | undefined;
    setGeneralInformation: (generalInformation: GeneralInformation | undefined) => void;
}

const defaultContextValue: DrillerProdContextProps = {
    equipments: {
        compressor: { equipment_id: undefined, start_time: 0, end_time: 0 },
        drill: { equipment_id: undefined, start_time: 0, end_time: 0 },
        truck: { equipment_id: undefined, start_time: 0, end_time: 0 },
    },
    setEquipments: () => {},
    generalInformation: undefined,
    setGeneralInformation: () => {},
};

const DrillerProdContext = createContext<DrillerProdContextProps>(defaultContextValue);


export default DrillerProdContext;